/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';

/**
 * 
 * @export
 * @interface GetFamilyPaymentAllocationResponse
 */
export interface GetFamilyPaymentAllocationResponse {
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetFamilyPaymentAllocationResponse
     */
    student: IdNameResultOfint;
    /**
     * 
     * @type {number}
     * @memberof GetFamilyPaymentAllocationResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetFamilyPaymentAllocationResponse
     */
    currency: string;
}

/**
 * Check if a given object implements the GetFamilyPaymentAllocationResponse interface.
 */
export function instanceOfGetFamilyPaymentAllocationResponse(value: object): value is GetFamilyPaymentAllocationResponse {
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function GetFamilyPaymentAllocationResponseFromJSON(json: any): GetFamilyPaymentAllocationResponse {
    return GetFamilyPaymentAllocationResponseFromJSONTyped(json, false);
}

export function GetFamilyPaymentAllocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFamilyPaymentAllocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'student': IdNameResultOfintFromJSON(json['student']),
        'totalAmount': json['totalAmount'],
        'currency': json['currency'],
    };
}

export function GetFamilyPaymentAllocationResponseToJSON(json: any): GetFamilyPaymentAllocationResponse {
    return GetFamilyPaymentAllocationResponseToJSONTyped(json, false);
}

export function GetFamilyPaymentAllocationResponseToJSONTyped(value?: GetFamilyPaymentAllocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'student': IdNameResultOfintToJSON(value['student']),
        'totalAmount': value['totalAmount'],
        'currency': value['currency'],
    };
}

